/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Page_Meta_DescInputs */

const en_serve_page_meta_desc = /** @type {(inputs: Serve_Page_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the Claude or ChatGPT subscription you already have. Your computer builds, Bystep guides, you try it on your phone.`)
};

const id_serve_page_meta_desc = /** @type {(inputs: Serve_Page_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakai langganan Claude atau ChatGPT yang sudah kamu punya. Komputermu membangun, Bystep memandu, kamu mencoba di HP.`)
};

/**
* | output |
* | --- |
* | "Use the Claude or ChatGPT subscription you already have. Your computer builds, Bystep guides, you try it on your phone." |
*
* @param {Serve_Page_Meta_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_page_meta_desc = /** @type {((inputs?: Serve_Page_Meta_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Page_Meta_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_page_meta_desc(inputs)
	return en_serve_page_meta_desc(inputs)
});